import { motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

export const BestFitStrip = () => {
  const items = [
    {
      k: "01",
      title: "Startups past 50",
      body: "Scaling headcount without an in-house HR leader — yet needing CHRO judgment.",
    },
    {
      k: "02",
      title: "SMEs professionalising",
      body: "Boards asking for structure, comp defensibility and audit-ready people ops.",
    },
    {
      k: "03",
      title: "PE / VC-backed",
      body: "Portfolio companies preparing for a raise, an audit or an integration.",
    },
    {
      k: "04",
      title: "M&A / multi-country",
      body: "Organisations navigating cross-border expansion, harmonisation or divestitures.",
    },
  ];

  return (
    <section className="relative bg-[var(--bg-2)] py-24 md:py-32 border-t border-[var(--line-strong)]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-4">
            <p className="overline mb-4">Best fit for</p>
          </div>
          <div className="md:col-span-8">
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.9, ease: EASE }}
              className="font-display text-3xl md:text-5xl tracking-[-0.02em] leading-[1.02] text-[var(--ink)]"
            >
              Four moments where a{" "}
              <span className="font-serif-accent italic text-[var(--accent)]">
                fractional HR
              </span>{" "}
              earns its keep.
            </motion.h2>
          </div>
        </div>

        <div className="grid md:grid-cols-4 gap-0 border-t border-[var(--line-strong)]">
          {items.map((it, i) => (
            <motion.div
              key={it.k}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.75, delay: 0.08 * i, ease: EASE }}
              className="p-8 md:p-10 border-b md:border-b-0 md:border-r border-[var(--line-strong)] last:border-r-0 hover:bg-[var(--bg-3)] transition-colors"
            >
              <div className="font-serif-accent italic text-[var(--accent)] text-2xl mb-6">
                {it.k}
              </div>
              <h3 className="font-display text-2xl tracking-tight text-[var(--ink)] mb-4">
                {it.title}
              </h3>
              <p className="text-[var(--ink-70)] text-sm leading-relaxed">
                {it.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BestFitStrip;
